// 範囲指定（マーキー）選択のドラッグ中に表示する選択枠。
// ステージ座標で配置するため、親のステージ（pan/zoom transform 配下）に置くことで
// pan/zoom に追従して正しい位置・サイズで表示される。枠自体はヒットを取らない
// （pointerEvents: none）ので、下のオブジェクトのドラッグ等を邪魔しない。

import { useCanvasStore } from "./store/canvas-store";

export function CanvasMarqueeOverlay(): JSX.Element | null {
  const rect = useCanvasStore((s) => s.marqueeRect);
  if (!rect) return null;
  return (
    <div
      data-testid="canvas-marquee-box"
      style={{
        position: "absolute",
        left: `${rect.x}px`,
        top: `${rect.y}px`,
        width: `${rect.w}px`,
        height: `${rect.h}px`,
        border: "1px solid var(--color-accent)",
        // アクセント色を薄く敷いた塗り。CSS 変数を直接 rgba 化できないため固定値で表現する。
        background: "rgba(96, 165, 250, 0.16)",
        pointerEvents: "none",
        zIndex: Number.MAX_SAFE_INTEGER,
      }}
    />
  );
}
